// extracted by mini-css-extract-plugin
export var bounce = "component-module--bounce--28b66";
export var cookieButtonsWrapper = "component-module--cookieButtonsWrapper--ded87";
export var cookieContent = "component-module--cookieContent--8c37d";
export var cookieContentWrapper = "component-module--cookieContentWrapper--d3f2c";
export var cookieHeader = "component-module--cookieHeader--862e7";
export var cookieWrapper = "component-module--cookieWrapper--3364b";
export var delayedAnimation = "component-module--delayedAnimation--49cec";
export var fadeIn = "component-module--fadeIn--fa868";
export var fullwidthButton = "component-module--fullwidthButton--85ab2";
export var noMargin = "component-module--noMargin--7bcca";
export var onScroll = "component-module--onScroll--d7bc9";